import React, { useState, useRef, useEffect, Fragment } from 'react';
import DropDownInput from '../Input/dropDownInput/dropDownInput';
import ActionDropDown from './ActionDropDown/actionDropDown';
import ActionBotton from './actionButton/actionButton';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import AcceptReject from 'components/sales/tableSection/acceptReject/acceptReject';
import ReactPaginate from 'react-paginate';
import './tablesection.css';
import ReactTooltip from "react-tooltip";
import { Link } from 'react-router-dom';
import Images from 'assets/images/imageData';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { toast } from 'react-toastify';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DispatchModel from 'components/sales/tableSection/dispatchModel/dispatchModel';
import { Button } from 'react-bootstrap';
import moment from "moment/moment";

const TableSection = ({
  data,
  headers,
  status,
  deal_status,
  ops_status,
  onChange,
  onChangeBulk = () => {},
  detailList,
  isId = true,
  isMngId = true,
  pageCount = 0,
  currentPage = 1,
  onPageChange = () => {},
  handleValue = () => {},
  reject = true,
  serialNo = true,
  postUpdatePMStatus,
  postApprovePmSite,
  postUpdateRMStatus,
  postUpdateEMStatus,
  updateCorpClient,
  deleteCorpClient,
  deleteMrfDetail,
  refreshPage = null,
  isBulkAssign = false,
  updateMrf = null,
  setIsbulk = false,
  setFileUrl,
  srNo = 1,
  setShowAddAdvancePopup = () => {},
  setShowAddPaymentPopup = () => {},
  setShowAdjustAdvancePopup = () => {},
  setShowDetailsPopup = () => {},
  setCurrentBusinessId = () => {},
  setCurrentInvoiceId = () => {},
  setCurrentContractId = () => {},
  setCurrentSiteNumber = () => {},
  setCurrentBusinessName = () => {},
  setCurrentContractType = () => {},
  setCurrentRowData = () => {},
  setIsView = () => {},
  setIsEdit = () => {},
  setChangeStatus = () => {},
  setCarnivalId = () => {},
  setProjectId = () => {},
  setStartDate = () => {},
  setEndDate = () => {},
  setCurrentcarnivalStatus = () => {},
  setShowRaisePopup = () => {},
  setPaymentReference =() => {},
  setLateFeeApplicable =() => {},
  setLateFee =() => {},
  setDueDate =() => {},
  setUnclaimedId = () => {},
  dontAppendLink = false,
  handleDownloadFlatFiles = '',
  handleMediaUrlFiles = '',
  handleInvoiceStart = '',
  handleRating = '',
  handleMeetingView = '',
  handleEye = '',
  isStatusId=false,
  helpdeskStatus = () => {},
  assignEngineerPopup = () => {},
  installmentRequestId = () => {},
  setCloseModal = () => {},
  closeModal = false,
  setInvoiceValidationCompletePopup= () => {},
  setCampaignId= () => {},
  isView = false,
  setLeadId = () => {},
  setSiteId = () => {},
  setChangeCarLoanStatusModalOpen = () => {},
  carLoanId = () => {},
}) => {
  const [listData, setListData] = useState([]);
  const [listIds, setListIds] = useState([]);
  const [listManageIds, setListManageIds] = useState([]);

  const [isChecked, setIsChecked] = useState(undefined);
  const [LeadStatus, setLeadStatus] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data && data.length) {
      if (!isId) {
        let idList = [];
        data.forEach((item) => {
          idList.push(item.id);
        });
        setListIds(idList);
      }

      if (!isMngId) {
        let mngIdList = [];
        data.forEach((item) => {
          mngIdList.push(item.manage_id);
        });
        setListManageIds(mngIdList);
      }
      setListData(data);
    } else setListData([]);
  }, [data]);

  const handleEditVendorRequest = async (email) => {
    if(email && email != '') {
      const payload = {
        'email':email
      }
      toast.warning('Request is sending, please wait...');
      const url = `${Config.preSalesList.vendorEditRequest}`;
      const res  = await axios.post(url,payload);
      if(res?.data?.response?.status) {
        toast.success('Request sent successfully.');
      }
    }
  };

  const getKeys = function () {
    if (listData && listData.length) {
      return Object.keys(listData[0]);
    }
  };

  function capitalizeFirstLetter(string) {
    string = string.replace(/_/g, ' ');
    return string
      .split(' ')
      .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(' ');
  }

  const getHeader = function () {
    let keys = [];
    if (headers) {
      keys = headers;
    } else keys = getKeys();
    return keys.map((key, index) => {
      if(key === 'Action' || key === 'Actions'){
        return <th key={key} style={{'text-align':'left'}}>{`#`}</th>;
      }else{
        return <th key={key}>{key}</th>;
      }
     
    });
  };
  const handleCheckboxChange = (checked) => {
    setIsChecked(checked.check);
    helpdeskStatus(checked)
    if (onChange) onChange(checked);
  };

  const handleLeadStatus = (data) => {
    setLeadStatus(data.status);
    if (onChange) onChange(data);
  };

  const handleBulkUpload = (checked, item) => {
    onChangeBulk(item, checked);
  };

  const renderSwitch = function (
    val,
    item,
    col,
    index,
    id,
    manageId,
    headerTitle
  ) {
    if (val === 'created_at') {
      item.created_at = item.created_at && item.created_at.slice(0, 10);
    }
    if (val === 'createdDate') {
      item.createdDate = item.createdDate && item.createdDate.slice(0, 10);
    }
    if (val === 'created_on') {
      item.created_on = item.created_on && item.created_on.slice(0, 10);
    }
    if (val === 'time') {
      item.time = moment(item.time).format("DD-MM-YYYY, HH:mm");
    }
    if(val.includes('handover_date')) {
      item[val] = item[val] && item[val].slice(0, 10);
    }
    if(val.includes('request_date')) {
      item[val] = item[val] && item[val].slice(0, 10);
    }
    if (val === 'address') {
      item.address1 = item.address;
      if(item.address.length > 25){
        item.address = item.address && item.address.slice(0, 25)+'...';
       
      }
      
    }
    switch (val) {
      case 'Action':
        return (
          <td key={index}>
            <span className="th" style={{minWidth: 'fit-content'}}>{headerTitle}</span>
            {/* {console.log(item)} */}
            <ActionDropDown
              id={item.id ? item.id : id ? id : item.ticket_id ? item.ticket_id : item.installment_request_id ? item.installment_request_id : '' }
              manageId={manageId}
              dontAppendLink={dontAppendLink}
              actionList={item[col[index]]}
              detailList={detailList}
              status={item.status}
              postUpdatePMStatus={postUpdatePMStatus}
              postApprovePmSite={postApprovePmSite}
              postUpdateRMStatus={postUpdateRMStatus}
              postUpdateEMStatus={postUpdateEMStatus}
              deleteCorpClient={deleteCorpClient}
              updateCorpClient={updateCorpClient}
              deleteMrfDetail={deleteMrfDetail}
              refreshPage={refreshPage}
              updateMrf={updateMrf}
              setIsbulk={setIsbulk}
              setFileUrl={setFileUrl}
              setShowAddAdvancePopup={setShowAddAdvancePopup}
              setShowAddPaymentPopup={setShowAddPaymentPopup}
              setShowAdjustAdvancePopup={setShowAdjustAdvancePopup}
              setShowDetailsPopup={setShowDetailsPopup}
              setCurrentBusinessId={setCurrentBusinessId}
              setCurrentInvoiceId={setCurrentInvoiceId}
              setCurrentContractId={setCurrentContractId}
              setCurrentSiteNumber={setCurrentSiteNumber}
              setCurrentBusinessName={setCurrentBusinessName}
              setCurrentRowData={setCurrentRowData}
              setCurrentContractType={setCurrentContractType}
              setIsView={setIsView}
              setIsEdit={setIsEdit}
              setChangeStatus={setChangeStatus}
              setCarnivalId={setCarnivalId}
              setProjectId={setProjectId}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setCurrentcarnivalStatus={setCurrentcarnivalStatus}
              setShowRaisePopup={setShowRaisePopup}
              setPaymentReference={setPaymentReference}
              setLateFeeApplicable={setLateFeeApplicable}
              setLateFee={setLateFee}
              setDueDate={setDueDate}
              setUnclaimedId={setUnclaimedId}
              assignEngineerPopup={assignEngineerPopup}
              installmentRequestId={installmentRequestId}
              setCloseModal={setCloseModal}
              closeModal={closeModal}
              setInvoiceValidationCompletePopup={setInvoiceValidationCompletePopup}
              setCampaignId={setCampaignId}
              setChangeCarLoanStatusModalOpen={setChangeCarLoanStatusModalOpen}
              carLoanId={carLoanId}
            />
          </td>
        );
      case 'Change Status':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <DropDownInput
              label="Change Status"
              data={status}
              disabled={false}
              getIdValue={(val) => {
                if (val && val.value !== item.status) {
                  const data = {
                    lead_id: id,
                    status: val.value,
                  };
                  handleLeadStatus(data);
                  setLeadStatus(val);
                }
              }}
            />
          </td>
        );
      case 'statusName':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>

            <div
              className={
                item.statusName === 'Presales Closed' ||
                item.statusName === 'Post Sale 1 Complete' ||
                item.statusName === 'Approved'
                  ? 'status-td proposal-sent'
                  : item.statusName === 'In Progress' ||
                    item.statusName === 'Under Approval' ||
                    item.statusName === 'Reopened' ||
                    item.statusName === 'To be consider in next PM' ||
                    item.statusName === 'Installation In Progress'
                  ? `status-td warm`
                  : `status-td ${
                      typeof item.statusName === 'string' &&
                      item.statusName.toLowerCase()
                    }`
              }
            >
              {item.statusName}
            </div>
          </td>
        );

      case 'status':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            {item.status !== 'Active' && item.status !== 'Inactive' ? (
              <div
                className={
                  item.status === 'Presales Closed' ||
                  item.status === 'Post Sale 1 Complete' ||
                  item.status === 'Approved' ||
                  item.status === 'Finance Approved' ||
                  item.status === 'Approved By Head'
                    ? 'status-td proposal-sent'
                    : item.status === 'In Progress' ||
                      item.status === 'Reopened' ||
                      item.status === 'To be consider in next PM' ||
                      item.status === 'Inspection In Progress' ||
                      item.status === 'Inspection Completed'||
                      item.status === 'Civil In Progress'||
                      item.status === 'Civil Completed'||
                      item.status === 'Installation In Progress' ||
                      item.status === 'Installation Completed'||
                      item.status === 'Handover in Progress' ||
                      item.status === 'Go Live In Progress' ||
                      item.status === 'Hold' ||
                      item.status === 'Amount Change' ||
                      item.status === 'Without Amount Change'
                    ? `status-td warm`
                    : item.status === 'New Site'
                    ? `status-td newSite` 
                    : item.status === 'Expired' 
                    ? `status-td d-expired`
                    : `status-td ${
                        typeof item.status === 'string' &&
                        item.status.toLowerCase()
                      }`
                }
              >
                {item.status}
              </div>
            ) : (
              <span className="check-slider">
                <input
                  type="checkbox"
                  name=""
                  id=""
                  checked={item.status === 'Active' ? true : ''}
                  onChange={(e) => {
                    // console.log(item.status)
                    const data = {
                      check: e.target.checked,
                      id: id,
                      status: item.status,
                    };

                    handleCheckboxChange(data);
                  }}
                />

                <span className="slider-status">
                  <span></span>
                </span>
              </span>
            )}
          </td>
        );
        case 'ops_status':
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
              {item.ops_status !== 'Active' && item.ops_status !== 'Inactive' ? (
                <div
                  className={
                    item.ops_status === 'Presales Closed' ||
                    item.ops_status === 'Post Sale 1 Complete' ||
                    item.ops_status === 'Approved'
                      ? 'status-td proposal-sent'
                      : item.ops_status === 'In Progress' ||
                        item.ops_status === 'Reopened' ||
                        item.ops_status === 'To be consider in next PM' ||
                        item.ops_status === 'Inspection In Progress' ||
                        item.ops_status === 'Inspection Completed'||
                        item.ops_status === 'Civil In Progress'||
                        item.ops_status === 'Civil Completed'||
                        item.ops_status === 'Installation In Progress' ||
                        item.ops_status === 'Installation Completed'||
                        item.ops_status === 'Handover in Progress' ||
                        item.ops_status === 'Hold'
                      ? `status-td warm`
                      : item.status === 'New Site'
                      ? `status-td newSite`
                      : `status-td ${
                          typeof item.ops_status === 'string' &&
                          item.ops_status.toLowerCase()
                        }`
                  }
                >
                  {item.ops_status?item.ops_status:'N/A'}
                </div>
              ) : (
                <span className="check-slider">
                  <input
                    type="checkbox"
                    name=""
                    id=""
                    checked={item.ops_status === 'Active'}
                    onChange={(e) => {
                      const data = {
                        check: e.target.checked,
                        id: id,
                        status: item.ops_status,
                      };
                      handleCheckboxChange(data);
                    }}
                  />
  
                  <span className="slider-status">
                    <span></span>
                  </span>
                </span>
              )}
            </td>
          );
          case 'project_status':
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
                <div
                  className={
                    item.project_status === 'Approved'
                      ? 'status-td proposal-sent'
                      : item.project_status === 'Pending' || item.project_status === 'Edit Request'
                      ? `status-td warm`
                      : `status-td ${
                          typeof item.ops_status === 'string' &&
                          item.ops_status.toLowerCase()
                        }`
                  }
                >
                  {item.project_status?item.project_status:'N/A'}
                </div>
              
            </td>
          );
      case 'Actions':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <b className="action_align">
            <ActionBotton 
              actionObj={item[col[index]]}
              detailList={detailList}
              id={isId ? (item.id ? item.id : id) : id}
              handleValue={handleValue}
              darkButton={item[col[index]].darkButton || false}
              // id={item.id ? item.id : id ? id : item.ticket_id}
              manageId={manageId}
              disabled={item[col[index]].disabled || false}
            />
            </b>
          </td>
        );
      case 'Approve/Reject':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            
            {(item['status'] == 'Approved' || item['status'] == 'Rejected' ||
             item['Approve/Reject'] === 'No') ? (
              ''
            ) : (
              <AcceptReject
                actionObj={isId ? item : { ...item, id }}
                reject={reject}
                onClick={(data) => onChange(data)}
                isView={isView}
                setLeadId={setLeadId}
                setSiteId={setSiteId}
              />
            )}
          </td>
        );
        case 'download_flats':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            {item['download_flats'] === 'Yes' ? (
              <button type="button" className="btn btn-primary" onClick={() => handleDownloadFlatFiles(item['site_no'])}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/></svg></button>
            ) : (
              ''
            )}
          </td>
        );
        case 'media_url':
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
              <button 
                type="button" 
                className="btn btn-primary" 
                onClick={() => handleMediaUrlFiles(item['media_url'])}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/>
                </svg>
              </button>
            </td>
          );

        case 'edit_vendor':
        return (
          <td key={index}>
            
            <span className="th text-center">{headerTitle}</span>
            {(
              (item['edit_vendor']) ? 
                <a className="btn btn-primary"  onClick={() => handleEditVendorRequest(item['email'])}>Edit Request</a>
              :
              <a className="btn btn-primary" disabled>Pending</a>
              // <a className="btn btn-primary"  onClick={() => handleEditVendorRequest(item['email'])}>Resend / Edit Request</a>
              
            )}
          </td>
        );
        case 'view_details':
        return (
          <td key={index} style={{'text-align':'left'}} >
            <span className="th">{headerTitle}</span>
            <Link to={item.view_details?item.view_details+'/'+(isId ? (item.id ? item.id : id) : id):'#'}>
            <img src={Images?.viewIcon} alt="" className="view-icon" />
            </Link>
          </td>
        );
        
      case 'is_location_validate':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <span className="check-slider">
              <input
                type="checkbox"
                name=""
                id=""
                checked={item.is_location_validate === 1 ? true : ''}
                onChange={(e) => {
                  const data = {
                    check: e.target.checked,
                    id: id,
                  };

                  handleCheckboxChange(data);
                }}
              />

              <span className="slider-status">
                <span></span>
              </span>
            </span>
          </td>
        );
        case 'mobile_no':
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
               <a href={`tel:${item.mobile_no}`}> {item.mobile_no}</a>
            </td>
          );
        case 'contact_no' :
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
               <a href={`tel:${item.contact_no}`}> {item.contact_no}</a>
            </td>
          );
        case 'address' :
          return (
            <td key={index} title={item.address1 ? item.address1: ''}>
              
              <span className="th" >{headerTitle}</span>
                <span >{item.address} </span>
               
                
            </td>
          );

        case 'Dispatch':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            {item['Dispatch'] === 'No' ? (
              <span className='dis-done'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-check2-all" viewBox="0 0 16 16">
               <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z"/>
               <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z"/>
              </svg>
              </span>
            ) : (
              <DispatchModel
                dispatchObj={isId ? item : { ...item, id }}
                onClick={(data) => onChange(data)}
              />
            )}
          </td>
        );

        case 'invoice_start':
          return (
            <>
            <td key={index}>
              <span className="th">{headerTitle}</span>
                <button type="button" className="btn btn-primary" 
                  onClick={(e) => handleInvoiceStart(item['invoice_start'], e)}
                >
                    Start Campaign
                </button>
            </td>
            </>
          );

        case 'Rate':
          return (
            <>
            <td key={index}>
              <span className="th">{headerTitle}</span>
              {item['already_rated'] !== 1 ?
                 <button type="button" className="btn btn-primary btn-sm" 
                 onClick={() => handleRating(id)}
               >
                   Rate
               </button>
               :
               "Rated"
              }
                {delete item['already_rated']}
            </td>
            </>
          );

          case 'View Meeting':
            return (
              <>
              <td key={index}>
                <span className="th">{headerTitle}</span>
                   <button type="button" className="btn btn-primary btn-sm" 
                   onClick={() => handleMeetingView(id)}
                 >
                     View
                 </button>
              </td>
              </>
          );
  

          case 'Eye':
            return (
              <>
                <span className='dis-done'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#6030be" className="bi bi-eye-fill"
                   viewBox="0 0 16 16"
                   onClick={() => handleEye(id)}
                  >
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                  </svg>
                </span>
              </>
            );


        case 'message':
        return (
          <td style={{'width':'20%'}} key={val} className="data-key" data-title={col[index]}>
           <span className="th">{headerTitle}</span>
            {item[col[index]] !== '' ? item[col[index]] : localization.na}
          </td>
        );
        case 'approval_status_id':
        return (
          ''
        ); 

      default:
        return (
          <td key={val} className="data-key" data-title={col[index]}>
            <span className="th">{headerTitle}</span>
            {item[col[index]] !== '' ? item[col[index]] : localization.na}
          </td>
        );
    }
  };

  const getRowsData = function () {
    return listData.map((items, ind) => {
      let newObj = {};
      let newCol = {};

      if (!isId || !isMngId) {
        let obj = {};
        Object.assign(obj, items);
        if (items.hasOwnProperty('id') || items.hasOwnProperty('manage_id')) {
          delete obj.id;
          newObj = obj;
          delete obj.manage_id;
          newObj = obj;
        } else {
          newObj = items;
        }
        newCol = Object.keys(obj);
      } else {
        newCol = Object.keys(items);
        newObj = items;
      }

      return (
        <tr key={ind}>
          {isBulkAssign && (
            <td>
              <input
                type="checkbox"
                onChange={(e) => handleBulkUpload(e.target.checked, items.id)}
                className="mr-2"
              />{' '}
            </td>
          )}
          {serialNo && (
            <td>
              <span className="th"></span>
              {srNo + ind}.
            </td>
          )}
          {newCol &&
            newCol.map((val, index) => {
              return renderSwitch(
                val,
                newObj,
                newCol,
                index,
                listIds[ind],
                listManageIds[ind],
                headers[index]
              );
            })}
        </tr>
      );
    });
  };

  return (
    <Fragment>
      {listData && listData.length ? (
        <Fragment>
          <table className="panel-table table table-striped">
            <thead>
              <tr>
                {isBulkAssign && <th></th>}
                {serialNo && <th>S.No.</th>}
                {getHeader()}
              </tr>
            </thead>
            <tbody>{getRowsData()}</tbody>
          </table>
          {pageCount > 0 && (
            <div className="panel-pagination-col panel-table-pagination">
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pageCount}
                forcePage={currentPage - 1}
                pageRangeDisplayed={5}
                onPageChange={onPageChange}
                activeClassName={'active'}
              />
            </div>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <div>
            {/*{localization.noRecord}*/}
            <img src={Images?.NoData} alt="" width="100%" />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

TableSection.propTypes = {
  handleDropdown: PropTypes.func,
};

export default TableSection;





